import * as React from 'react';
import { RefObject } from 'react';
import { IonList, IonText } from '@ionic/react';
import Page from '../../../components/core/Page';
import { Proforma } from '../../../models';
import OrderCard from './OrderCard/OrderCard';

interface Props {
    orders: Proforma[];
    isFetching: boolean;
    doRefresh: () => void;
    refresherRef: RefObject<HTMLIonRefresherElement>;
}

export const OrdersPage: React.FC<Props> = ({ orders, isFetching, doRefresh, refresherRef }) => {
    return (
        <Page
            title="My Orders"
            showMenuButton={false}
            showBackButton={true}
            backRouterLink="/my-shop"
            showLoading={isFetching && orders.length === 0}
            doRefresh={doRefresh}
            refresherRef={refresherRef}
        >
            {!isFetching && orders.length === 0 && (
                <div className="ion-padding">
                    <IonText color="medium">
                        <p>No orders yet.</p>
                    </IonText>
                </div>
            )}

            <IonList lines="full">
                {orders.map((order) => (
                    <OrderCard key={order.uuid} order={order} />
                ))}
            </IonList>
        </Page>
    );
};
